import { makeStyles } from "@fluentui/react-components";
import { customTokens, customTypographyStyles } from "../../theme/theme";

export const useAIClimateAssistantStyles = makeStyles({
  container: {
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    backgroundColor: customTokens.colorNeutralBackground1,
    boxShadow: "0 -4px 12px 4px rgba(25, 25, 112, 0.16)",
    zIndex: 9999,
    padding: "24px 32px",
    display: "flex",
    gap: "16px",
    flexDirection: "column",
    margin: "0 120px",

    "@media (max-width: 1440px)": {
      margin: "0 64px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      margin: "0 20px",
      padding: "16px",
    },

    "@media (max-width: 768px)": {
      margin: "0 20px",
      padding: "16px",
    },

    "@media print": {
      display: "none !important",
    },
  },

  mobileContainerCollapsed: {
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    backgroundColor: customTokens.colorNeutralBackground1,
    boxShadow: "0 -4px 12px 4px rgba(25, 25, 112, 0.16)",
    zIndex: 9999,
    padding: "16px",
    display: "flex",
    gap: "16px",
    flexDirection: "column",

    "@media print": {
      display: "none !important",
    },
  },

  mobileContainerExpanded: {
    display: "flex",
    gap: "16px",
    flexDirection: "column",
    padding: "16px",
    backgroundColor: customTokens.colorNeutralBackground1,

    "@media print": {
      display: "none !important",
    },
  },
});

export const useHeaderStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  logo: {
    background: customTokens.colorNeutralForegroundInverted,
    padding: "8px",
    width: "32px",
    height: "32px",
    borderRadius: customTokens.borderRadiusCircular,
  },

  headingText: {
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
  },

  newChatButton: {
    color: customTokens.colorBrandBackground,
    marginRight: "auto",
  },

  newChatButtonDesktop: {
    color: customTokens.colorBrandBackground,
    marginLeft: "auto",
  },

  mobileHeaderContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  mobileHeaderTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  mobileHeaderBottomRow: {
    display: "flex",
    alignItems: "center",
  },
});

export const useChatWindowStyles = makeStyles({
  chatWindow: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },

  mobileScrollWindow: {
    background: customTokens.colorNeutralBackground1,
    maxHeight: "calc(100vh - 385px)",
    overflow: "auto",
  },

  scrollWindow: {
    background: customTokens.colorNeutralBackground1,
    maxHeight: "300px",
    overflow: "auto",
  },

  userQueryBubbleWrapper: {
    display: "flex",
    alignItems: "flex-end",
    gap: "4px",
    maxWidth: "590px",
    width: "fit-content",
    margin: "48px 42px 48px auto",

    "@media (max-width: 768px)": {
      marginRight: "0",
    },
  },

  userQueryBubble: {
    padding: `${customTokens.spacingHorizontalM} ${customTokens.spacingHorizontalL}`,
    borderRadius: "16px",
    background: customTokens.globalColorBrand150,
  },

  userQueryEditBtn: {
    padding: "8px",
    color: customTokens.colorNeutralForeground2,
    cursor: "pointer",
    flex: "none",
  },

  userQueryLoadingBubble: {
    padding: `${customTokens.spacingHorizontalM} ${customTokens.spacingHorizontalL}`,
    maxWidth: "590px",
    width: "fit-content",
    margin: "48px 42px 48px auto",
    borderRadius: "16px",
    background: customTokens.globalColorBrand150,
  },

  newSessionBubble: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  errorBubble: {
    padding: "16px",
    borderRadius: "8px",
    border: `1px solid ${customTokens.colorStatusDangerBackground3}`,
    background: customTokens.colorStatusDangerBackground1,
    maxWidth: "772px",
  },

  textBubble: {
    maxWidth: "772px",
    wordBreak: "break-word",
  },

  analysisTextBubble: {
    wordBreak: "break-word",
  },

  newTopicWrapper: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },

  newTopic: {
    background: "#C6E7EA",
    padding: "2px 8px",
    borderRadius: "200px",
    flex: "none",
  },

  tableBubble: {
    maxWidth: "772px",
    marginTop: "16px",
    wordBreak: "break-word",
  },

  csvBubble: {
    maxWidth: "772px",
    marginTop: "16px",
    wordBreak: "break-word",
  },

  responseContainer: {
    display: "flex",
    gap: "8px",
  },

  responseWrapper: {
    padding: "2px 8px",
    display: "flex",
    width: "fit-content",
    gap: "8px",
    alignItems: "center",
    background: customTokens.globalColorBrand160,
    borderRadius: "200px",
    color: customTokens.colorBrandBackground,
  },

  avatar: {
    background: customTokens.colorNeutralForegroundInverted,
    padding: "4px",
    width: "24px",
    height: "24px",
    borderRadius: customTokens.borderRadiusCircular,
  },

  responseChild: {
    padding: "0 42px",
    marginTop: "16px",

    "@media (max-width: 768px)": {
      padding: "0",
    },
  },

  graphBubbleContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "16px 32px",
    borderRadius: "16px",
    background: customTokens.globalColorBrand160,
    maxWidth: "614px",
    marginTop: "16px",
    position: "relative",
  },

  graphWrapper: {
    marginTop: "16px",
  },

  downloadGraphBtn: {
    position: "absolute",
    right: "16px",
    top: "16px",
  },
});

export const useInputBoxStyles = makeStyles({
  input: {
    padding: "4px",
    borderRadius: "32px",
    border: `1px solid ${customTokens.colorNeutralBackground1}`,
    background: `linear-gradient(0deg, ${customTokens.colorNeutralBackground1} 0%, ${customTokens.colorNeutralBackground4} 100%)`,
    boxShadow: `0 16px 24px -2px ${customTokens.colorNeutralShadowAmbientLighter}`,

    "& .fui-Input": {
      border: "none",

      "&::after": {
        border: "none",
      },

      "& ::placeholder": {
        color: customTokens.colorNeutralForeground4,
        ...customTypographyStyles.bodyMRegular,
      },
    },
  },

  collapsedInput: {
    borderRadius: "28px",
    width: "100%",
    padding: "12px",
    color: customTokens.colorNeutralForeground1,
    ...customTypographyStyles.bodyMRegular,
  },

  chatInputWrapper: {
    borderRadius: "32px",
    boxShadow: `0 16px 24px -2px ${customTokens.colorNeutralShadowAmbientLighter}`,
    padding: "4px",
    background: `linear-gradient(180deg, ${customTokens.colorNeutralBackground3} 0%, ${customTokens.colorNeutralBackground2} 100%)`,
    width: "100%",
    boxSizing: "border-box",
  },

  chatInputContainer: {
    borderRadius: "28px",
    padding: "0 12px",
    background: customTokens.colorNeutralBackground1,
  },

  topRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingTop: "16px",

    "& .fui-Textarea": {
      "> textarea": {
        padding: "0 8px",
        color: customTokens.colorNeutralForeground1,
        ...customTypographyStyles.bodyMRegular,
        border: "none",
      },

      "&:hover": {
        border: "none",
      },

      "&:focus-within": {
        outline: "none",
        border: "none",
      },
    },
  },

  expandedInput: {
    flexGrow: 1,
    border: "none",

    "&::after": {
      border: "none",
    },
  },

  iconButton: {
    padding: "4px",
    minWidth: "28px",
    height: "28px",
  },

  bottomRow: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "16px",
    padding: "12px 0",
  },

  charCount: {
    padding: "0 8px",
  },

  errorText: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    color: customTokens.colorStatusDangerForeground1,
  },

  sendButton: {
    marginLeft: "auto",
    background: customTokens.colorBrandBackground,

    "&:hover": {
      background: customTokens.colorBrandBackground,
    },
  },

  viewMorePromptButton: {
    color: customTokens.colorBrandBackground,
    marginLeft: "auto",
  },
});

export const usePromptWindowStyles = makeStyles({
  promptWindow: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginTop: "16px",
  },

  promptContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",

    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  },

  promptBox: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "16px",
    borderRadius: "16px",
    border: `1px solid ${customTokens.colorNeutralStroke2}`,
    background: customTokens.colorNeutralBackground1,
    cursor: "pointer",
    // maxWidth: "384px",
  },

  tagWrapper: {
    display: "flex",
    gap: "8px",
  },

  tag: {
    borderRadius: "4px",
    border: `1px solid ${customTokens.colorTransparentStroke}`,
    padding: "2px 6px",
  },

  showMorePromptButton: {
    display: "flex",
    margin: "16px auto 0 auto",
    color: customTokens.colorBrandBackground,
    ...customTypographyStyles.body1Strong,
  },
});

export const usePromptDrawerStyles = makeStyles({
  drawerContainer: {
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
  },

  drawerHeader: {
    padding: "16px 20px",
    borderBottom: "0.33px solid rgba(0, 0, 0, 0.30)",
    textAlign: "center",
  },

  tabPanel: {
    marginTop: "64px",
  },

  tabList: {
    position: "fixed",
    background: customTokens.colorNeutralBackground1,
    width: "100%",
  },
});
